var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFileLargeMeisai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_3077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 4H36L40 8L44 12V46H6V4Z",
    fill: "#F9C030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11L17 16L21 11",
    stroke: "#00506C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16V23",
    stroke: "#00506C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17H22",
    stroke: "#00506C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20H22",
    stroke: "#00506C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 13,
    fill: "#0098CB",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2479 30.8641H30.6719V33.5521H33.2479V30.8641ZM30.6719 37.6801H33.2479V34.8801H30.6719V37.6801ZM34.6239 39.0561H30.6719V40.4961H29.2959V29.5041H34.6239V39.0561ZM37.3119 36.8641H41.3919V34.4001H37.3919V34.9281C37.3919 35.5361 37.3759 36.1921 37.3119 36.8641ZM41.3919 30.6081H37.3919V33.0401H41.3919V30.6081ZM42.8639 29.2321V41.4401C42.8639 42.2721 42.6559 42.7201 42.1119 42.9601C41.5519 43.2001 40.6719 43.2321 39.3279 43.2321C39.2479 42.8321 39.0079 42.1761 38.7839 41.7921C39.7439 41.8241 40.7199 41.8081 41.0079 41.8081C41.2799 41.7921 41.3919 41.6961 41.3919 41.4241V38.2241H37.1039C36.7359 40.1121 35.9039 42.0161 34.0959 43.3761C33.8879 43.0721 33.3119 42.5601 32.9919 42.3521C35.6639 40.3521 35.9359 37.3601 35.9359 34.9121V29.2321H42.8639Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_3077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileLargeMeisai);
export default __webpack_public_path__ + "static/media/icon-file_large-meisai.d2e5c6ae153ee2ec8820f55d37118e8a.svg";
export { ForwardRef as ReactComponent };